import { c as _c } from "react/compiler-runtime";
export default function GroupCreateWrapper(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="tw-mt-4 lg:tw-mt-6 tailwind-scope tw-relative"><div>{children}</div></div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}